export const promoteOldestLimited = (state) => {
    const oldestLimited = Array.from(state.displayOrder, (id) => state.toasts.get(id)).find((toast) => toast != null && !toast.ending && toast.limited);
    if (oldestLimited == null) {
        return state;
    }
    const updatedToasts = new Map(state.toasts);
    updatedToasts.set(oldestLimited.id, {
        ...oldestLimited,
        limited: false,
    });
    return {
        ...state,
        toasts: updatedToasts,
    };
};
//# sourceMappingURL=promoteOldestLimited.js.map